import { useQuery } from '@tanstack/react-query';
import { Link, createFileRoute } from '@tanstack/react-router';

import { ContentCard } from '@/features/subscriber/ContentCard';
import { useAuth } from '@/lib/auth/useAuth';
import { subscriberQueries } from '@/lib/queries/subscriber';

export const Route = createFileRoute('/subscriber/feed')({
  component: FeedRoute,
});

function FeedRoute() {
  const { user } = useAuth();
  const feed = useQuery(subscriberQueries.feed(user?.id));
  const items = feed.data ?? [];

  return (
    <div className="mx-auto max-w-5xl">
      <h1 className="font-serif text-3xl text-ink">Following</h1>
      <p className="mt-2 font-sans text-sm text-ink/60">
        The latest from contributors you follow, newest first.
      </p>
      {feed.isLoading ? (
        <p className="mt-12 text-center font-sans text-sm text-ink/50">Loading…</p>
      ) : items.length === 0 ? (
        <div className="mt-12 rounded-lg border border-ink/10 bg-parchment p-8 text-center">
          <p className="font-serif text-lg text-ink">You&apos;re not following anyone yet</p>
          <p className="mt-2 font-sans text-sm text-ink/70">
            Follow a few contributors and their new work shows up here.
          </p>
          <Link
            to="/subscriber/contributors"
            className="mt-6 inline-block rounded-md bg-ink px-4 py-2 font-sans text-sm font-medium text-parchment hover:bg-oxblood"
          >
            Browse contributors
          </Link>
        </div>
      ) : (
        <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((item) => (
            <ContentCard key={item.content_id} item={item} />
          ))}
        </div>
      )}
    </div>
  );
}
